export default __webpack_public_path__ + "static/media/tqicon-11.c7c7a45b.svg";